import { IOperationType } from './statwidget.interface';
import dayjs from 'dayjs';
import { total } from '../../store';
const defaultColors = ['#3498db', '#2ecc71', '#e74c3c', '#9b59b6', '#1abc9c', '#2c3e50'];
export function prepareData(widget, response) {
    if (widget.type === 'table') {
        return response;
    }
    return prepareTimeseriesData(widget, response);
}
function getActionCount(data, widget, actionIdx) {
    const action = widget.query.actions[actionIdx];
    const foundData = data.find(({ key }) => {
        return key === action;
    });
    return (foundData === null || foundData === void 0 ? void 0 : foundData.doc_count) || 0;
}
export function prepareTimeseriesData(widget, response) {
    var _a;
    const xAxis = {
        title: false,
        categories: [],
        crosshair: true,
    };
    const series = [];
    const plotOptions = {
        line: {
            marker: {
                enabled: false,
            },
        },
    };
    for (let dataIdx = 0; dataIdx < widget.query.actions.length; dataIdx++) {
        if (!series[dataIdx]) {
            const name = getSerieName(widget, dataIdx);
            const color = getSerieColor(widget, dataIdx);
            series.push({
                name,
                color,
                data: [],
            });
        }
    }
    response.columns.forEach((dataItem) => {
        xAxis.categories.push(dayjs(dataItem.timestamp).format(widget.formatTime));
        for (let dataIdx = 0; dataIdx < widget.query.actions.length; dataIdx++) {
            series[dataIdx].data.push(getActionCount(dataItem.data, widget, dataIdx));
        }
    });
    (_a = widget.additionalFields) === null || _a === void 0 ? void 0 : _a.forEach((additionalField) => {
        xAxis.categories.push(dayjs(response.columns[0].timestamp).format(widget.formatTime));
        const additionalData = [];
        let totalCount = 0;
        if (additionalField.operation === IOperationType.Difference) {
            const dataSize = response.columns.length;
            for (let i = 0; i < dataSize; i++) {
                const firstParameter = additionalField.parameters[0];
                const secondParameter = additionalField.parameters[1];
                const dailyInstallUninstallSum = getActionCount(response.columns[i].data, widget, firstParameter) -
                    getActionCount(response.columns[i].data, widget, secondParameter);
                const dailyTotal = Number(additionalData[i - 1] || 0) + Number(dailyInstallUninstallSum);
                additionalData.push([dailyTotal]);
            }
            series.push({
                name: additionalField.name,
                color: additionalField.color,
                data: additionalData,
            });
        }
        if (additionalField.operation === IOperationType.Summation) {
            const dataSize = response.columns.length;
            for (let i = 0; i < dataSize; i++) {
                const firstParameter = additionalField.parameters[0];
                totalCount += getActionCount(response.columns[i].data, widget, firstParameter);
            }
            total.set(totalCount);
        }
    });
    return {
        xAxis,
        yAxis: {
            title: false,
            maxPadding: 0,
        },
        series,
        plotOptions,
        title: false,
        tooltip: { shared: true },
        chart: {
            backgroundColor: 'transparent',
            type: widget.type === 'bars' ? 'column' : 'line',
        },
    };
}
function getSerieName(widget, index) {
    var _a;
    return (_a = widget.fieldTitles) === null || _a === void 0 ? void 0 : _a[index];
}
function getSerieColor(widget, index) {
    var _a;
    return ((_a = widget.lineColors) === null || _a === void 0 ? void 0 : _a[index]) || defaultColors[index];
}
